/**
 * Checks if an error is a network-related error
 */
export const isNetworkError = (error) => {
  if (!error) return false

  // Axios Specific Check
  if (error.code === 'ERR_NETWORK') return true

  // Check for common network error patterns
  return error.message?.includes?.('Network Error') ?? false
}

/**
 * Checks if an error is related to printing
 * by examining the error message or response code.
 *
 * @param {Object} error
 */
export const isPrintError = (error) => {
  const responseCode = error?.response?.data?.responseCode

  // Kitchen Print Response Codes
  if (responseCode?.includes('KPM-')) {
    return true
  }

  // WebSocket Print Response Codes
  if (responseCode?.includes('PW-')) {
    return true
  }

  // Fallback to checking application message
  const applicationMessage = error?.response?.data?.applicationMessage
  return applicationMessage?.includes('print') || false
}
